import { fetchImages } from "../../services/api";

export default {
  namespaced: true,

  state: {
    all: [],
  },

  getters: {
    getBuildImage(state, getters, rootState, globalGetters){
      const {color, plug, system, double, socket} = rootState.build

      let type = globalGetters['types/current'];
      let method = globalGetters['methods/current'];

      return state.all.find((image) => {
        if (type.type === 'laadpaal') {
          let socketSelected = socket ? image.socket_id !== null : image.socket_id === null;

          if (method.with_plugs) {
            return (
              image.color_id === color &&
              image.method_id === method.id &&
              image.plug_id === plug &&
              image.system_id === system &&
              image.type_id === type.id &&
              socketSelected
            );
          } else {
            return (
              image.color_id === color &&
              image.method_id === method.id &&
              image.system_id === system &&
              image.type_id === type.id &&
              socketSelected
            );
          }
        } else {
          return (
            image.type_id === type.id &&
            image.double === double
          );
        }
      });
    },
  },
  actions: {
    fetch: ({ commit, rootState }) => {
      return fetchImages(rootState.environmentId).then(({ data }) => {
        commit('SET_IMAGES', data);
      });
    },
  },
  mutations: {
    SET_IMAGES: (state, data) => {
      state.all = data;
    },
  },
};
